import './ProjectDissertation.css';
import DynamicPdfCard from '../../include/DynamicPdfCard';
import React, { useState, useEffect } from 'react';
import api from '../../../../api';
import DynamicBanner from '../../include/DynamicBanner';

const ProjectDissertation = () => {
  const [docData, setDocData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocData = async () => {
      try {
        const response = await api.get(
          "/api/sitepages/academic/gen-doc"
        );

        const data = response.data;

       const images = data?.data?.banner_section?.images || [];
data.data.banner_section.images = images.map(img =>
  img.startsWith("/")
    ? img
    : `/${img.replace("./", "")}`
);

const mobileImages = data?.data?.banner_section?.mobile_images || [];
data.data.banner_section.mobile_images = mobileImages.map(img =>
  img.startsWith("/")
    ? img
    : `/${img.replace("./", "")}`
);


        setDocData(response.data);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching Project Dissertation data:", err);
        setError("Failed to load data. Please try again.");
        setIsLoading(false);
      }
    };

    fetchDocData();
  }, []);

  if (isLoading || error || !docData) {
    return null;
  }

  const bannerSection = docData.data?.banner_section || {};
  console.log(bannerSection);
  const documentSection = docData.data?.documents_section || {};
  const heading = documentSection.heading || "";
  const documents = (documentSection.documents || []).map((doc) => ({
    title: doc.title,
    pdfLink: `/${doc.file}`,
    type: doc.file.endsWith(".pdf") ? "pdf" : "word"
  }));


  return (
    <section className="e-sanad-page">

      {bannerSection.images.length > 0 && (
        <DynamicBanner title={bannerSection.heading} bgImage={bannerSection.images}  bgImageMobile={bannerSection.mobile_images}/>
      )}
      <DynamicPdfCard
        heading={heading}
        documents={documents}
      />
    </section>
  );
};

export default ProjectDissertation;
